function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _components = require("../../../../../components");
var _native = require("@react-navigation/native");
var _useLang = require("../useLang");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["offsetY", "showBackButton", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var TopBar = exports.TopBar = (0, _react.memo)(function (_ref) {
  var _ref$offsetY = _ref.offsetY,
    offsetY = _ref$offsetY === void 0 ? new _reactNative.Animated.Value(0) : _ref$offsetY,
    _ref$showBackButton = _ref.showBackButton,
    showBackButton = _ref$showBackButton === void 0 ? false : _ref$showBackButton,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var navigation = (0, _react.useContext)(_native.NavigationContext);
  var _useState = (0, _react.useState)(t('onboardingShared:backPreviousStep')),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _backLabel = _useState2[0],
    _setBackLabel = _useState2[1];
  if ((navigation == null ? void 0 : navigation.canGoBack()) === false) {
    showBackButton = false;
  }
  var _onPress = function _onPress() {
    navigation == null ? void 0 : navigation.goBack();
  };
  (0, _react.useEffect)(function () {
    var _backAction = function _backAction() {
      if (showBackButton) navigation == null ? void 0 : navigation.goBack();
      return true;
    };
    var _backHandler = _reactNative.BackHandler.addEventListener('hardwareBackPress', _backAction);
    return function () {
      _backHandler.remove();
    };
  }, [navigation, showBackButton]);
  (0, _react.useLayoutEffect)(function () {
    var _navigation$getState;
    if (navigation != null && navigation.setOptions) {
      navigation.setOptions({
        gestureEnabled: showBackButton
      });
    }
    var _routes = (navigation == null ? void 0 : (_navigation$getState = navigation.getState()) == null ? void 0 : _navigation$getState.routes) || [];
    var _prevRoute = _routes[_routes.length - 2];
    if (_prevRoute != null && _prevRoute.name) {
      var _pageTitle = t("onboardingShared:pages.".concat(_prevRoute.name));
      _setBackLabel(t('onboardingShared:back', {
        value: _pageTitle
      }));
    }
  }, [navigation, showBackButton, t]);
  return (0, _jsxRuntime.jsx)(_components.TopBar, Object.assign({
    showBackButton: showBackButton,
    offsetY: offsetY,
    onBackButtonPress: _onPress,
    backButtonLabel: _backLabel,
    style: style
  }, props));
});